export const SET_SEGREGATE_TYPE = 'SET_SEGREGATE_TYPE';

export const SET_SPLIT_RATIO = 'SET_SPLIT_RATIO';

export const SET_TRAIN_TAG = 'SET_TRAIN_TAG';

export const SET_TEST_TAG = 'SET_TEST_TAG';

export const SET_IS_EXISTING_TAG_MODAL = 'SET_IS_EXISTING_TAG_MODAL';

export const SET_IS_CONFIRMATION_MODAL_OPEN = 'SET_IS_CONFIRMATION_MODAL_OPEN';
